import { useEffect, useRef, useState } from "react";
import { searchAll } from "./common-filter";
import GlobalSearchIcon from "../../assets/icons/GlobalSearchIcon.svg"
import crossSearch from "../../assets/icons/x-close.svg"
// import "./GlobalSearch.css"
import { RenderIf } from "../../helpers/formatter";

export default function GlobalSearch(props) {
  console.log("props of global search", props)
  const searchRef = useRef();
  const [searchInput, setSearchInput] = useState("")
  const [showSearchBar, setShowSearchBar] = useState(props.isSearchOpen)
  const [showGlobal, setShowGlobal] = useState(false);

  function search(searchText) {
    if (props.data && props.data.length > 0) {
      let obj = props.searchList ? props.searchList : {};
      obj["GlobalSearch"] = { 0: searchText }
      let propsTemp = { setData: props.setData, data: props.data, header: props.headers };
      searchAll(propsTemp, obj)
    }

  }

  useEffect(() => {
    setSearchInput("");
    setShowSearchBar(props.isSearchOpen)
    props.setShowDownButn(true);
  }, [props.dataType])

  useEffect(() => {
    search(searchInput);
  }, [searchInput])

  useEffect(() => {
    if (showSearchBar) {
      searchRef.current.focus();
    }
  }, [showSearchBar])


  return (
    <div className={`global-search-box show`}>

      <img
        className="search-icon"
        src={GlobalSearchIcon}
        alt="search"
        onClick={() => setShowGlobal(true)}
      />
      {/* {showGlobal && ( */}

      <input
        ref={searchRef}
        className="search-bar"
        type="text"
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        aria-label="Search"
        aria-describedby="search"
        placeholder={`Search within '${props.sessionName}'`}
        style={{ width: '38vw' }}

      />
      {/* )} */}
      {/* <RenderIf isTrue={showGlobal}> */}
      {/* {showGlobal && ( */}

        <img
          size={20}
          src={crossSearch}
          color="black"
          className="search-icon-cross"
          onClick={(e) => {
            setShowGlobal(false);
            setSearchInput("");
          }}
        />
      {/* )} */}
      {/* </RenderIf> */}
    </div>
  )
}